import React, { useContext } from "react";
import DraftStateContext from "../../contexts/draftStateContext";
import useDraft from "../../hooks/queryResults/draft/useDraft";
import useDraftPicks from "../../hooks/queryResults/draft/useDraftPicks";
import useAllPlayers from "../../hooks/queryResults/useAllPlayers";
import useIsLoading from "../../hooks/queryResults/useIsLoading";
import useLeagueSeason from "../../hooks/queryResults/useLeagueSeason";
import useTeams from "../../hooks/queryResults/useTeams";
import Util from "../../util/util";
import Loading from "../ui/Loading";
import DraftStartsCountdown from "./DraftStartsCountdown";
import styled from "styled-components";
import PlayerCard from "./PlayerCard";
import TeamLogoWithRosterLink from "./TeamLogoWithRosterLink";

const StyledContainerDiv = styled.div`
  text-align: center;
  padding: 0.25rem;
`;

export default function Info() {
  const draftState = useContext(DraftStateContext);
  const {
    isChoosingSpots,
    hasStarted,
    hasFirstPickBeenMade,
    hasLastPickBeenMade,
    isPaused,
    hasEnded,
    pickNumOnClock,
  } = draftState.info;
  const { draftData, draftQuery } = useDraft();
  const { draftPicksData, draftPicksQuery } = useDraftPicks();
  const { playersData, playersQuery } = useAllPlayers();
  const { teams, teamsQuery } = useTeams();
  const { league, leagueSeason, leagueQuery } = useLeagueSeason();

  const isLoading = useIsLoading(
    draftData,
    draftQuery,
    draftPicksData,
    draftPicksQuery,
    playersData,
    playersQuery,
    teams,
    teamsQuery,
    league,
    leagueSeason,
    leagueQuery
  );
  if (isLoading) return <Loading />;

  if (!hasStarted) return <DraftStartsCountdown />;

  if (isChoosingSpots) {
    return (
      <StyledContainerDiv>
        <h2>Choosing Spots</h2>
        <p>Before picking players, each team chooses their draft spot.</p>
      </StyledContainerDiv>
    );
  }

  if (hasEnded) {
    return (
      <StyledContainerDiv>
        <h1>The draft has ended.</h1>
      </StyledContainerDiv>
    );
  }

  if (hasStarted && isPaused) {
    return (
      <StyledContainerDiv>
        <h1>The draft is PAUSED</h1>
      </StyledContainerDiv>
    );
  }

  if (hasStarted && !hasFirstPickBeenMade) {
    return (
      <StyledContainerDiv>
        <h1>The draft has begun!</h1>
      </StyledContainerDiv>
    );
  }

  if (hasStarted && hasFirstPickBeenMade) {
    const pick = hasLastPickBeenMade
      ? draftPicksData.picks[draftPicksData.picks.length - 1]
      : draftPicksData.picks[pickNumOnClock - 2];
    const player = playersData.players[pick.player];
    const team = teams.getTeamById(pick.team);
    let teamLogo = null;
    if (team) teamLogo = <TeamLogoWithRosterLink team={team} size={"md"} />;

    if (player)
      return (
        <div
          style={{
            color: "black",
            backgroundColor: "#e6f2ff",
            borderRadius: "1rem",
            marginBottom: "0.5rem",
          }}
        >
          <div style={{ padding: "0.5rem", fontSize: "0.75rem" }}>
            With the {Util.toOrdinal(pick.pickNum)} pick in the{" "}
            {leagueSeason.obj.season} {league.obj.abbr} draft, {team.fullName}{" "}
            select...
          </div>
          <PlayerCard
            player={player}
            leftSide={teamLogo}
            isAnimated={true}
            style={{ color: "black" }}
          />
        </div>
      );
  }

  return null;
}
